module.exports = __webpack_public_path__ + "img/homepage-content-image-cjdr.716e3b58.jpg";